import Component from '../component/component';
import Helpers from '../helpers/helpers';

import './user.scss';

import './img/fb.svg';
import './img/smart.svg';

export default class User extends Component {
    static initSelector: string = '.user';

    public toggle: HTMLElement;
    public linkContainer: HTMLElement;

    constructor(target: HTMLElement) {
        super(target);

        this.toggle = this.element.querySelector('.js-user-button');
        this.linkContainer = this.element.querySelector('.user__account-links');

        if (this.toggle && this.linkContainer) {
            this.init();
        }
    }

    init(): void {
        this.toggle.addEventListener('click', this.toggleHandler.bind(this));
        document.addEventListener('click', this.handleOutsideClick.bind(this));
    }

    toggleHandler(event: MouseEvent): void {
        event.preventDefault();

        this.linkContainer.classList.toggle('is-open');
    }

    handleOutsideClick(event: MouseEvent): void {
        if (event.target instanceof HTMLElement) {
            if (!event.target.classList.contains('user') && !Helpers.parents(event.target, '.user').length) {
                this.linkContainer.classList.remove('is-open');
            }
        }
    }

    destroy(): void {
        document.removeEventListener('click', this.handleOutsideClick.bind(this));
    }
}
